import MerchantSupportApi from '@/api/merchant/support'

const state = {
  submitting: false,
  errorData: null,
  visibleCallbackDialog: false,
}

const getters = {}

const mutations = {
  SET_SUBMITTING(state, submitting) {
    state.submitting = submitting
  },
  SET_SUBMITTING_ERROR(state, errorData) {
    state.errorData = errorData
  },
  SET_VISIBLE_CALLBACK_DIALOG(state, visible) {
    state.visibleCallbackDialog = visible
  },
}

const actions = {
  toggleCallbackDialog({ commit }, visible) {
    commit('SET_VISIBLE_CALLBACK_DIALOG', visible)
  },
  async submitCallbackRequest({ commit }, data) {
    commit('SET_SUBMITTING', true)
    commit('SET_SUBMITTING_ERROR', null)

    try {
      await MerchantSupportApi.submitCallbackRequest(data)
    } catch (error) {
      commit('SET_SUBMITTING_ERROR', error)

      throw error
    } finally {
      commit('SET_SUBMITTING', false)
    }
  },
}

export default { namespaced: true, state, getters, mutations, actions }
